import { useHistory } from 'react-router';
import { FiCheckCircle } from 'react-icons/fi';
import React from 'react';
import { /* IoShareSocialOutline,  */ IoCloseSharp } from 'react-icons/io5';
// import { FacebookShareButton, TwitterShareButton } from 'react-share';
import { PropsFromRedux } from '.';
import { API_KEYS } from '../../../../interfaces/api';

interface Props extends PropsFromRedux {}

const Confirmation: React.FC<Props> = ({
  hideModal,
  resetApi,
  createShipmentState,
  user,
}) => {
  const history = useHistory();

  const closeModal = () => {
    hideModal();
    resetApi(API_KEYS.CREATE_INTL_SHIPMENT_REQUEST);
    history.push('/');
  };
  return (
    <div className="w-full px-4 bg-white rounded-md lg:px-14 py-10 relative">
      <button type="button" aria-label="Close" onClick={closeModal}>
        <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
      </button>

      <h4 className="text-center text-2xl mb-5 font-bold">
        Item registration Completed
      </h4>
      <div className="w-full flex justify-center items-center">
        <FiCheckCircle
          className="text-green-600"
          style={{ fontSize: '120px' }}
        />
      </div>
      <div className="w-full max-w-lg mx-auto py-8">
        <p className="text-center mb-5 text-gray-700 font-medium">
          Your shipment registration with transaction ID{' '}
          {createShipmentState?.response?.Object?.RequestNumber} was successful.
        </p>
        <p className="text-gray-400 italic mb-5">
          You should receive an email from us shortly containing a summary of
          your global shipping request
        </p>
      </div>
      <div className="bg-black p-4 mb-10 max-w-md mx-auto text-sm text-white opacity-80 rounded-2xl">
        <p className="italic ">Hello {user?.response?.Object.FirstName}</p>
        <p>
          Please share the GIGGo App with your social circle to ease their
          pick-up and delivery needs.
        </p>
      </div>
      {/*  <div className="flex justify-center w-full">
        <FacebookShareButton
          resetButtonStyle={false}
          className="mb-5 text-white bg-black text-sm py-4 px-8 flex justify-center items-center rounded-3xl"
          url="https://play.google.com/store/apps/details?id=ng.giglogistics.giglgo"
        >
          <IoShareSocialOutline className="mr-2 text-xl" />
          Share on Facebook
        </FacebookShareButton>{' '}
        <TwitterShareButton
          resetButtonStyle={false}
          title="Download the GIGL Mobile app"
          via="GIGL Website"
          className="mb-5 text-white bg-black text-sm py-4 px-8 flex justify-center items-center rounded-3xl"
          url="https://play.google.com/store/apps/details?id=ng.giglogistics.giglgo"
        >
          <IoShareSocialOutline className="mr-2 text-xl" />
          Share on Twitter
        </TwitterShareButton>
      </div> */}
    </div>
  );
};

export default Confirmation;
